import React from 'react';

import Filters from '../filters';
import { useTasks } from '../context/tasks_context';

import type { ReactNode } from 'react';
import type { Props as FiltersProps } from '../filters';

export type TasksFiltersProps = Omit<FiltersProps, 'children' | 'features' | 'withLabels'>;

interface Props {
  children?: ReactNode;
  withLabels?: boolean;
}

export function TasksFilters({ children, withLabels }: Props) {
  const { features, filtersConfig } = useTasks();

  return (
    <Filters {...filtersConfig} features={features} withLabels={withLabels}>
      {children}
    </Filters>
  );
}
